import React from 'react';
import { profile } from '../data';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-socials">
        <a href={profile.socials.github} target="_blank" rel="noreferrer" aria-label="GitHub">
          <i className="fa-brands fa-github"></i>
        </a>
        <a href={profile.socials.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn">
          <i className="fa-brands fa-linkedin-in"></i>
        </a>
        <a href={`mailto:${profile.email}`} aria-label="Email">
          <i className="fa-solid fa-envelope"></i>
        </a>
      </div>
      <div>
        Designed &amp; built by <strong>{profile.name}</strong> · © {new Date().getFullYear()}
      </div>
    </footer>
  );
}

export default Footer;
